import React, { Component } from "react";
import Resource from "./Resource";
import ReactPaginate from "react-paginate";

class Results extends Component {
  constructor(props) {
    super(props);

    this.handlePageClick = this.handlePageClick.bind(this);
  }
  handlePageClick(data) {
    var newPage = data.selected + 1;
    this.props.onPageClick(newPage);
  }
  render() {
    var page = this.props.page;
    var perPage = this.props.perPage;
    var resources = this.props.items;
    var offset = (page - 1) * perPage;
    var items = resources.slice(offset, offset + perPage);

    return (
      <div className="results" itemScope itemType="http://schema.org/ItemList">
        <div className="results__count">
          <strong itemProp="numberOfItems">{this.props.items.length}</strong>{" "}
          results found
        </div>

        <div className="results__items">
          <ul className="list list--block">
            {items.map((resource, index) => (
              <Resource key={resource.id} data={resource} />
            ))}
          </ul>
        </div>

        <div className="results__pagination">
          <nav className="pagination elementary">
            <ReactPaginate
              previousLabel={"previous"}
              nextLabel={"next"}
              breakLabel={<a href="">...</a>}
              breakClassName={"break-me"}
              pageCount={this.props.pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={this.handlePageClick}
              containerClassName={"pagination__items"}
              pageClassName={"pagination__item"}
              pageLinkClassName={"pagination__link"}
              activeClassName={"pagination__item--active"}
              previousClassName={"pagination__item"}
              previousLinkClassName={"pagination__link"}
              previousLabel={"<"}
              nextClassName={"pagination__item"}
              nextLinkClassName={"pagination__link"}
              nextLabel={">"}
              disabledClassName={"pagination__item--disabled"}
              forcePage={this.props.page - 1}
            />
          </nav>
        </div>
      </div>
    );
  }
}

export default Results;
